import { useQuery } from '@apollo/client';
import { GET_PA_DOCUMENT_FOR_REVIEWER } from 'graphql/queries';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

export const ReviewerReviewPaViewModel = () => {
  const [formDetails, setFormDetails] = useState<any>();
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useQuery(GET_PA_DOCUMENT_FOR_REVIEWER, {
    variables: {
      getPaDocumentInput: {
        id,
      },
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (data) {
      setFormDetails(data?.getPaDocument);
    }
  }, [data]);

  // eslint-disable-next-line no-console
  console.log('info', formDetails);

  return {
    formDetails,
    data,
    loading,
  };
};
